export const Marquee = ({ items, className = "", "data-testid": testId }) => {
  const content = (
    <div className="marquee__track" aria-hidden="false">
      {items.map((item, i) => (
        <span key={i} className="flex items-center gap-10 shrink-0">
          <span
            className="font-head uppercase whitespace-nowrap"
            style={{
              fontSize: "clamp(18px, 2.4vw, 30px)",
              fontWeight: 800,
              letterSpacing: "0.04em",
              color: "var(--text-light)",
            }}
          >
            {item}
          </span>
          <span
            style={{
              width: 8,
              height: 8,
              borderRadius: 999,
              background: "var(--gold)",
              display: "inline-block",
            }}
          />
        </span>
      ))}
    </div>
  );
  return (
    <div className={`marquee ${className}`} data-testid={testId}>
      {content}
      <div className="marquee__track" aria-hidden="true">
        {items.map((item, i) => (
          <span key={`d${i}`} className="flex items-center gap-10 shrink-0">
            <span
              className="font-head uppercase whitespace-nowrap"
              style={{
                fontSize: "clamp(18px, 2.4vw, 30px)",
                fontWeight: 800,
                letterSpacing: "0.04em",
                color: "var(--text-light)",
              }}
            >
              {item}
            </span>
            <span
              style={{
                width: 8,
                height: 8,
                borderRadius: 999,
                background: "var(--gold)",
                display: "inline-block",
              }}
            />
          </span>
        ))}
      </div>
    </div>
  );
};
